import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    X,
    YOUTUBE
} from '@/lib/socialProfile';

export const MENTIONS_TYPE = {
    TYPE_TAG: 'tag',
    TYPE_CAPTION: 'caption',
    TYPE_COMMENT: 'comment'
} as const;

export type MentionsTypesType = ValueOfObject<typeof MENTIONS_TYPE>;

export const IG_POST_TYPES = {
    TYPE_PHOTO: 'photo',
    TYPE_VIDEO: 'video',
    TYPE_CAROUSEL: 'carousel',
    TYPE_REEL: 'reel',
    TYPE_IG_TV: 'ig_tv'
} as const;

export type IGPostTypesType = ValueOfObject<typeof IG_POST_TYPES>;

export const IG_STORY_TYPES = {
    TYPE_PHOTO: 'photo',
    TYPE_VIDEO: 'video'
} as const;

export type IGStoryTypesType = ValueOfObject<typeof IG_STORY_TYPES>;

export const TI_POST_TYPES = {
    TYPE_VIDEO: 'video'
} as const;

export type TIPostTypesType = ValueOfObject<typeof TI_POST_TYPES>;

export const YT_POST_TYPES = {
    TYPE_VIDEO: 'video',
    TYPE_SHORT: 'short'
} as const;

export type YTPostTypesType = ValueOfObject<typeof YT_POST_TYPES>;

export const FB_POST_TYPES = {
    TYPE_PHOTO: 'photo',
    TYPE_VIDEO: 'video',
    TYPE_CAROUSEL: 'carousel',
    TYPE_STORY: 'story',
    TYPE_STATUS: 'mobile_status',
    TYPE_REEL: 'reel'
} as const;

export type FBPostTypesType = ValueOfObject<typeof FB_POST_TYPES>;

export const TW_POST_TYPES = {
    TYPE_STATUS: 'status',
    TYPE_PHOTO: 'photo',
    TYPE_VIDEO: 'video',
    TYPE_CAROUSEL: 'carousel',
    TYPE_RETWEET: 'retweet',
    TYPE_RETWEET_COMMENT: 'quote',
    TYPE_QUOTE: 'quote',
    TYPE_LINK: 'link',
    TYPE_REPLY: 'reply',
    TYPE_POLL: 'poll'
} as const;

export type TWPostTypesType = ValueOfObject<typeof TW_POST_TYPES>;

export const LI_POST_TYPES = {
    TYPE_PHOTO: 'photo',
    TYPE_VIDEO: 'video',
    TYPE_CAROUSEL: 'carousel',
    TYPE_STATUS: 'status',
    TYPE_LINK: 'link',
    TYPE_DOCUMENT: 'document',
    TYPE_POLL: 'poll'
} as const;

export type LIPostTypesType = ValueOfObject<typeof LI_POST_TYPES>;

export const PI_POST_TYPES = {
    TYPE_IMAGE: 'image',
    TYPE_MULTIPLE_IMAGES: 'multiple_images',
    TYPE_MULTIPLE_MIXED: 'multiple_mixed',
    TYPE_MULTIPLE_VIDEOS: 'multiple_videos',
    TYPE_VIDEO: 'video'
} as const;

export type PIPostTypesType = ValueOfObject<typeof PI_POST_TYPES>;

type CommonPostType = { mediasLength?: number };

type GetPostTypeType =
    | (CommonPostType & {
          network: typeof INSTAGRAM;
          type: IGPostTypesType | IGStoryTypesType;
      })
    | (CommonPostType & {
          network: typeof FACEBOOK;
          type: FBPostTypesType;
      })
    | (CommonPostType & {
          network: typeof LINKEDIN;
          type: LIPostTypesType;
      })
    | (CommonPostType & {
          network: typeof TWITTER;
          type: TWPostTypesType;
      })
    | (CommonPostType & {
          network: typeof X;
          type: TWPostTypesType;
      })
    | (CommonPostType & {
          network: typeof TIKTOK_BUSINESS;
          type: TIPostTypesType;
      })
    | (CommonPostType & {
          network: typeof YOUTUBE;
          type: YTPostTypesType;
      })
    | (CommonPostType & {
          network: typeof PINTEREST;
          type: PIPostTypesType;
      });

export function getPostType({ network, type, mediasLength = undefined }: GetPostTypeType) {
    switch (network) {
        case FACEBOOK:
            if (type === FB_POST_TYPES.TYPE_PHOTO && mediasLength > 1) {
                return FB_POST_TYPES.TYPE_CAROUSEL;
            } else if (type === FB_POST_TYPES.TYPE_STORY) {
                if (mediasLength > 1) {
                    return FB_POST_TYPES.TYPE_CAROUSEL;
                } else if (mediasLength === 1) {
                    return FB_POST_TYPES.TYPE_PHOTO;
                }

                return FB_POST_TYPES.TYPE_STATUS;
            }
            return type;
        case INSTAGRAM:
        case LINKEDIN:
        case PINTEREST:
        case TIKTOK_BUSINESS:
        case TWITTER:
        case X:
        case YOUTUBE:
            return type;
    }
}

export const STORIES = 'stories';
export const MEDIAS = 'medias';

//Post layout format
export const STORY = 'story';
export const POST = 'post';
export const TWITTER_REPLY = 'TWITTER_REPLY';
export const X_REPLY = 'X_REPLY';
export const SQUARE = 'square';
export const COMPETITOR = 'competitor';
export const MENTION = 'mention';
export const HASHTAG = 'hashtag';

export const EXPORT_ENDPOINT_TYPES = {
    [STORY]: 'stories',
    [POST]: 'posts',
    [STORIES]: 'stories',
    [TWITTER_REPLY]: 'replies',
    [X_REPLY]: 'replies',
    [COMPETITOR]: 'competitors',
    [MENTION]: 'tags_mentions',
    [HASHTAG]: 'hashtags'
} as const;
